import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';
import { Link } from 'react-router';

export class RegisteredOrdersTitle extends React.Component {

  static propTypes = {
    total: PropTypes.number.isRequired
  };

  render () {
    return (
      <div className='registered-orders-title-wrapper'>
        <div className='registered-orders-title'>
          <Translate content='REGISTERED_ASSIGNMENTS_TITLE' />
          <Link to='economy/register-assignment'>
            <Translate content='REGISTERED_ASSIGNMENTS_TITLE_SHOW_ALL' />
          </Link>
        </div>
        <p className='registered-orders-description'>
          <Translate
            content='REGISTERED_ASSIGNMENTS_DESCRIPTION'
            insurancesLink={
              <b>
                <Link to='/insurances'>
                  <Translate content='REGISTERED_ASSIGNMENTS_DESCRIPTION_INSURANCES_LINK' />
                </Link>
              </b>
            }
            workingConditionsLink={
              <b>
                <Link to='working-environment'>
                  <Translate content='REGISTERED_ASSIGNMENTS_DESCRIPTION_WORKING_CONDITIONS_LINK' />
                </Link>
              </b>
            }
          />
        </p>
      </div>
    );
  }
}

export default RegisteredOrdersTitle;



/** WEBPACK FOOTER **
 ** ./src/components/registered-orders/registered-orders-title.js
 **/